class ProfitsSummary {
    rebates;
    rents;
    sales;
    totalAmount;
    constructor(data) {
        this.rebates = data.rebates;
        this.rents = data.rents;
        this.sales = data.sales;
        this.totalAmount = data.totalAmount;
    }
}
export default ProfitsSummary;
